module.exports = __webpack_public_path__ + "img/certificate-4.b51869ae.png";